var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row",class:_vm.classes,style:({ ..._vm.styles, ..._vm.cssVars })},[_vm._l((_vm.fields),function(field){return [_c('componentRenderer',{key:field.id,class:`col-lg-${_vm.getColumns(field)}`,attrs:{"field":field},on:{"component-updated":_vm.updated}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }